"use client";

import { useQuery, useMutation } from "convex/react";
import { api } from "../../convex/_generated/api";
import { useEffect } from "react";

export function SeedLoader() {
  const isSeeded = useQuery(api.seed.isSeeded);
  const seedAll = useMutation(api.seed.seedAll);

  useEffect(() => {
    if (isSeeded === false) {
      seedAll({}).catch(console.error);
    }
  }, [isSeeded, seedAll]);

  return null;
}
